import { render, staticRenderFns } from "./SuiteForm.vue?vue&type=template&id=39e8a72e&"
import script from "./SuiteForm.vue?vue&type=script&lang=js&"
export * from "./SuiteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports